module.exports = __webpack_public_path__ + "static/media/personal-folder-bg.8a882f31.png";